// Load-bearing: únicos UAs documentados que carregam `Version/` + `Safari/` sem ser Safari.
//   CriOS/                → Chrome iOS em "Request Desktop Site" manda Version/ E CriOS/
//   Android, Chrome/, wv  → WebView do Android manda `Version/4.0 ... Mobile Safari/537.36`
// Defesa futura, hoje redundantes (esses wrappers substituem o `Version/`, ou já caem
// nas exclusões acima): FxiOS, EdgiOS, OPiOS, GSA, SamsungBrowser, OPR, Firefox.
const SAFARI_EXCLUSIONS =
  /CriOS\/|FxiOS\/|EdgiOS\/|OPiOS\/|GSA\/|OPR\/|SamsungBrowser\/|Firefox\/|Chrome\/|Chromium\/|Android|;\s*wv[;)]/i;

const SAFARI_MARKER = /Version\/\d+(?:\.\d+)*.*Safari/i;

export const isSafariUserAgent = (): boolean => {
  if (typeof navigator === "undefined") return false;

  const { userAgent } = navigator;

  return SAFARI_MARKER.test(userAgent) && !SAFARI_EXCLUSIONS.test(userAgent);
};
